export const GENDER_OPTIONS = [
  { value: "male", description: "Male" },
  { value: "female", description: "Female" },
];

export const IDENTITY_TYPE_OPTIONS = [
  { value: "national_id", description: "National ID" },
  { value: "foreign_id", description: "Foreign ID" },
];

export const TAX_STATUS_OPTIONS = [
  { value: "resident", description: "Resident and Deemed Resident (Standard)" },
  { value: "apprentice_no_nssf", description: "Apprentice No NSSF" },
  {
    value: "disability_tax_exemption",
    description: "Disability Tax Exemption",
  },
  {
    value: "foreign_employment",
    description: "Foreign Employment (No Relief)",
  },
  {
    value: "secondary_employment_excl_nssf_shif",
    description: "Secondary Employment (fixed rate) excl. NSSF & SHIF",
  },
  {
    value: "secondary_employment_incl_nssf_shif",
    description: "Secondary Employment (fixed rate) incl. NSSF & SHIF",
  },
];
